import { createStyles } from '@mantine/core';

import { SplashLoader } from '~/domains/common/components/SplashLoader/SplashLoader';
import Container from '~/domains/design-system/Container';
import { TUTORIAL_PLACEMENTS } from '~/domains/cms/tutorials/const';

import { QuickPickLayout } from '../../components/QuickPickLayout/QuickPickLayout';
import Board from '../../components/Board/Board';
import useQuickPicksEnterCheck from '../../hooks/useQuickPicksEnterCheck';
import { BoardProvider } from '../../context/BoardContext/BoardContext';
import ConfirmationModalContextProvider from '../../context/QuickPickConfirmationModalContext/ConfirmationModalContextProvider';
import TutorialModalContextProvider from '../../../../../tutorials/TutorialModalContextProvider';

const useStyles = createStyles(() => ({
  container: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
}));

function QuickPicksBoardPage() {
  const { isLoading, isEnabled } = useQuickPicksEnterCheck();
  const { classes } = useStyles();

  if (isLoading) {
    return <SplashLoader />;
  }

  if (!isEnabled) {
    return {
      notFound: true,
    };
  }

  return (
    <ConfirmationModalContextProvider>
      <TutorialModalContextProvider type={TUTORIAL_PLACEMENTS.TUTORIAL_QUICK_PICKS_BOARD}>
        <QuickPickLayout>
          <BoardProvider>
            <Container className={classes.container}>
              <Board />
            </Container>
          </BoardProvider>
        </QuickPickLayout>
      </TutorialModalContextProvider>
    </ConfirmationModalContextProvider>
  );
}

QuickPicksBoardPage.isPublic = true;

export default QuickPicksBoardPage;
